import { APIS } from "constants/api.constant";
import ApiService from "./ApiService";
import BaseService from "./BaseService";

export function getApi(endpoint, params) {
  return BaseService.get(endpoint, { params }).then((res) => res?.data);
}

export function postApi(endpoint, payload) {
  return BaseService.post(endpoint, payload).then((res) => res?.data);
}
export function putApi(endpoint, payload) {
  return BaseService.put(endpoint, payload).then((res) => res?.data);
}

/** PUT /admin/updateUser/{slug} — body: { name?, image?, password?, shopName?, countryCode?, number? } */
export function updateUserBySlug(slug, payload) {
  const safeSlug = encodeURIComponent(String(slug));
  return putApi(`${APIS.UPDATE_USER}/${safeSlug}`, payload);
}
export function deleteApi(endpoint, payload) {
  return BaseService.delete(endpoint, payload).then((res) => res?.data);
}

/** PUT /admin/updateSubAdmin/{slug} */
export function updateSubAdminBySlug(slug, payload) {
  const safeSlug = encodeURIComponent(String(slug));
  return putApi(`${APIS.UPDATE_SUB_ADMIN}/${safeSlug}`, payload);
}

export async function apiGetNotificationCount() {
  return ApiService.fetchData({
    url: "/notification/count",
    method: "get",
  });
}

export async function apiGetNotificationList() {
  return ApiService.fetchData({
    url: "/notification/list",
    method: "get",
  });
}

export async function apiGetSearchResult(data) {
  return ApiService.fetchData({
    url: "/search/query",
    method: "post",
    data,
  });
}
